<template>
  <v-dialog v-model="dialog" max-width="290px">
    <v-card
      style="border-radius:20px;"
      class="py-2 strategio-card-container"
    >
      <v-card-title class="layout py-2 justify-center"
        style="font-size:20px;"
      >
        <v-layout column>
          <v-flex>
            Eliminar
          </v-flex>
          <v-flex style="font-size:16px;">
            {{itemName}}
          </v-flex>
        </v-layout>
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        ¿Está seguro de que desea borrar este item? <br />
        <b v-if="isFolder">Todos los items dentro serán borrados también</b>
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="v-layout justify-center">
        <!-- <v-spacer></v-spacer> -->
          <!-- color="grey darken-2" -->
          <!-- flat="flat" -->
        <v-btn
          small depressed rounded dark
          class="strategio-dialog-button"
          color="grey"
          @click.native="dialog = false"
        >Cerrar</v-btn>
          <!-- color="red darken-1" -->
          <!-- flat="flat" -->
        <v-btn
          small depressed rounded dark
          class="strategio-dialog-button"
          color="error"
          @click.native="dropItem()"
        >Eliminar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '../../utils/eventBus'

import reportsStorage from '../../storage/reportsStorage'
import structureStorage from '../../storage/structureStorage'

export default {
  name: 'drop-item-dialog',
  data () {
    return {
      dialog: false,
      itemName: '',
      itemID: '',
      isFolder: false,
      // El método para actualizar los datos
      //  reemplaza toda la información del item
      //  por eso esta se trae y usa, en silencio.
      description: '',
      labels: '',
      imageUrl: '',

      heritable: false,
      containedBy: '',
      structureID: ''
    }
  },
  methods: {
    dropItem () {
      if (this.heritable) {
        if (this.isFolder) {
          let [structureItemInheritanceFlag, structureID] = (/^(HI?)(\d+)$/.exec(this.itemID) && /^(HI?)(\d+)$/.exec(this.itemID).slice(1)) || [false, 0]
          structureStorage.removeStructure({
            data: {
              structureID: structureID,
              structureItemInheritance: structureItemInheritanceFlag.startsWith('HI')
            },
            onSuccess: () => {
              eventBus.$emit('open-custom-snack-bar', {message: 'Se ha eliminado la estructura correctamente', itsOk: true})
              // emit to routes/main-page.vue
              eventBus.$emit('reload-items')
              this.dialog = false
            },
            onError: (error) => {
              console.warn('Error removing item: ', error)
              eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema eliminando la estructura', itsOk: false})

              this.dialog = false
            }
          })
        } else {
          structureStorage.updateHeritableItem({
            data: {
              containedBy: this.containedBy,
              structureID: this.structureID,
              isFolder: this.isFolder,
              itemID: this.itemID,
              itemName: this.itemName,
              description: this.description,
              labels: this.labels,
              imageUrl: this.imageUrl,
              removed: true
            },
            onSuccess: () => {
              eventBus.$emit('open-custom-snack-bar', {message: 'Se ha eliminado el item correctamente', itsOk: true})
              // emit to routes/main-page.vue
              eventBus.$emit('reload-items')
              this.dialog = false
            },
            onError: (error) => {
              console.warn('Error removing item: ', error)
              eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema eliminando el item', itsOk: false})
            }
          })
        }
      } else {
        this.dialog = false
        reportsStorage.removeItem(this.itemID, {
          onSuccess: (response, removedItem) => {
            // emit to routes/main-page.vue
            eventBus.$emit('reload-items', {})
            // emit to custom-snack-bar
            eventBus.$emit('open-custom-snack-bar', {
              message: 'Se ha eliminado un item',
              itsOk: 'warning',
              snackAction: {
                title: 'Deshacer',
                action: () => {
                  reportsStorage.unDoRemoveItem(removedItem[0], {
                    onSuccess: () => {
                    // emit to routes/main-page.vue
                      eventBus.$emit('reload-items', {})
                      // emit to custom-snack-bar
                      eventBus.$emit('open-custom-snack-bar', {
                        message: 'El item ha sido restablecido',
                        itsOk: true
                      })
                    },
                    onError: () => {
                      // emit to custom-snack-bar
                      eventBus.$emit('open-custom-snack-bar', {
                        message: 'No ha posido restablecerse el item',
                        itsOk: false
                      })
                    }
                  })
                }
              }
            })
          },
          onError: () => {
            eventBus.$emit('open-custom-snack-bar', {
              message: 'El item no ha podido ser eliminado',
              itsOk: false
            })
          }
        })
      }
    }
  },
  created () {
    eventBus.$off('drop-item')
    eventBus.$on('drop-item', (item) => {
      this.itemName = item.itemName
      this.itemID = item.itemID
      this.isFolder = item.isFolder

      this.description = item.description
      this.labels = item.labels
      this.imageUrl = item.imageUrl

      this.heritable = item.heritable
      this.containedBy = item.containedBy
      this.structureID = item.origin
      this.dialog = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/drop-item-dialog.vue